export interface FixedAsset {
  id: string;
  companyId: string;
  companyName: string;
  code: string;
  name: string;
  supplierId: string;
  supplierName: string;
  costCenterId: string;
  costCenterName: string;
  assetAccountId: string;
  assetAccountName: string;
  acquisitionDate: string;
  status: 'active' | 'retired' | 'disposed';
}

/**
 * Áreas de valoración de un activo. El backend las guarda como texto libre, pero
 * exige 'fiscal' (no 'tax') — comprobado empíricamente: con 'tax' el INSERT de
 * fixed_asset_valuations_create falla en silencio (sin error, sin persistir).
 */
export type ValuationArea = 'accounting' | 'fiscal' | 'derived';

export const VALUATION_AREA_LABELS: Record<ValuationArea, string> = {
  accounting: 'Contable',
  fiscal: 'Fiscal',
  derived: 'Derivada'
};

export interface FixedAssetValuation {
  id: string;
  fixedAssetId: string;
  fixedAssetName: string;
  valuationArea: ValuationArea;
  acquisitionValue: number;
  depreciationMethodId: string;
  depreciationMethodCode: string;
  depreciationMethodName: string;
  usefulLifeMonths: number;
  residualValue: number;
  depreciationStartDate: string;
  accumulatedDepreciation: number;
}

export interface FixedAssetValuationPayload {
  fixedAssetId: string;
  valuationArea: ValuationArea;
  acquisitionValue: number;
  depreciationMethodId: string;
  usefulLifeMonths: number;
  residualValue: number;
  depreciationStartDate: string;
  accumulatedDepreciation?: number;
}

export interface DepreciationEntry {
  id: string;
  fixedAssetValuationId: string;
  fiscalYear: number;
  period: number;
  movementType: string;
  plannedAmount: number;
  status: 'planned' | 'posted';
  postedAt: string;
  journalEntryId: string;
}

export interface FixedAssetPayload {
  companyId: string;
  code: string;
  name: string;
  supplierId?: string;
  costCenterId?: string;
  assetAccountId?: string;
  acquisitionDate: string;
  status?: 'active' | 'retired' | 'disposed';
}

// Activo con su valoración contable y todas sus cuotas
export interface AccountingSchedule {
  asset: FixedAsset;
  valuation: FixedAssetValuation | null;
  entries: DepreciationEntry[];
}
